export const states = [
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['American Samoa', 'AS'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['Armed Forces Americas', 'AA'],
  ['Armed Forces Europe', 'AE'],
  ['Armed Forces Pacific', 'AP'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District Of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Guam', 'GU'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Louisiana', 'LA'],
  ['Maine', 'ME'],
  ['Marshall Islands', 'MH'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Northern Mariana Islands', 'NP'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Puerto Rico', 'PR'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['US Virgin Islands', 'VI'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
];

export const provinces = [
  ['Alberta', 'AB'],
  ['British Columbia', 'BC'],
  ['Manitoba', 'MB'],
  ['New Brunswick', 'NB'],
  ['Newfoundland', 'NF'],
  ['Northwest Territory', 'NT'],
  ['Nova Scotia', 'NS'],
  ['Nunavut', 'NU'],
  ['Ontario', 'ON'],
  ['Prince Edward Island', 'PE'],
  ['Quebec', 'QC'],
  ['Saskatchewan', 'SK'],
  ['Yukon', 'YT'],
];

export const mexicoStates = [
  ['Aguascalientes', 'AGU'],
  ['Baja California', 'BCN'],
  ['Baja California Sur', 'BCS'],
  ['Campeche', 'CAM'],
  ['Chiapas', 'CHP'],
  ['Chihuahua', 'CHH'],
  ['Ciudad de Mexico', 'CMX'],
  ['Coahuila', 'COA'],
  ['Colima', 'COL'],
  ['Durango', 'DUR'],
  ['Guanajuato', 'GUA'],
  ['Guerrero', 'GRO'],
  ['Hidalgo', 'HID'],
  ['Jalisco', 'JAL'],
  ['Mexico', 'MEX'],
  ['Michoacan', 'MIC'],
  ['Morelos', 'MOR'],
  ['Nayarit', 'NAY'],
  ['Nuevo Leon', 'NLE'],
  ['Oaxaca', 'OAX'],
  ['Puebla', 'PUE'],
  ['Queretaro', 'QUE'],
  ['Quintana Roo', 'ROO'],
  ['San Luis Potosi', 'SLP'],
  ['Sinaloa', 'SIN'],
  ['Sonora', 'SON'],
  ['Tabasco', 'TAB'],
  ['Tamaulipas', 'TAM'],
  ['Tlaxcala', 'TLA'],
  ['Veracruz', 'VER'],
  ['Yucatan', 'YUC'],
  ['Zacatecas', 'ZAC'],
];

export const peruStates = [
  ['Amazonas', 'AMA'],
  ['Ancash', 'ANC'],
  ['Apurimac', 'APU'],
  ['Arequipa', 'AQP'],
  ['Ayacucho', 'AYA'],
  ['Cajamarca', 'CAJ'],
  ['Callao', 'CAL'],
  ['Cusco', 'CUS'],
  ['Huancavelica', 'HUV'],
  ['Huanuco', 'HUC'],
  ['Ica', 'ICA'],
  ['Junin', 'JUN'],
  ['La Libertad', 'LAL'],
  ['Lambayeque', 'LAM'],
  ['Lima', 'LIM'],
  ['Lima Metropolitana', 'LMA'],
  ['Loreto', 'LOR'],
  ['Madre de Dios', 'MDD'],
  ['Moquegua', 'MOQ'],
  ['Pasco', 'PAS'],
  ['Piura', 'PIU'],
  ['Puno', 'PUN'],
  ['San Martin', 'SAM'],
  ['Tacna', 'TAC'],
  ['Tumbes', 'TUM'],
  ['Ucayali', 'UCA'],
];

export const allStates = {
  US: states,
  CA: provinces,
  MX: mexicoStates,
  PE: peruStates,
}